import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { ManageMapComponent } from './manage-map.component';
const routes: Routes = [
  {
    path: '',
    component: ManageMapComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageMapRoutingModule { }
